export default class FieldValidator {
	static isValidOption(option) {
		return option.price_type && option.price;
	}

	static hasValidPricing(field) {
		return (
			(field.has_price && field.price && field.price_type) ||
			(field.has_options &&
				field.options.some(FieldValidator.isValidOption))
		);
	}
}
